import { keyframes } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';

const scrollLeft = keyframes({
  from: { transform: 'translateX(0)' },
  to: { transform: 'translateX(-50%)' },
});

export const summaryBarStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    paddingBlock: theme.spacing(2),
    overflow: 'hidden',
  }),
  // The animated strip — twice the content, sliding left by exactly half its
  // width so the loop point is invisible.
  // Duration is scaled to the repeated content length (4x the base item
  // list per half) so the visual speed stays comfortable rather than
  // whipping past 4x faster.
  //
  // Deliberately never pauses on hover: a ticker that stops when the mouse
  // lands on it reads as an interactive/clickable element (it isn't), and
  // resuming from a dead stop looks like a jump/reset rather than smooth
  // continuous motion.
  track: {
    display: 'flex',
    width: 'max-content',
    animation: `${scrollLeft} 90s linear infinite`,
  },
  itemsGroup: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.spacing(3),
    paddingInline: theme.spacing(1.5),
  }),
  item: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  }),
  icon: { width: 16, height: 16, flexShrink: 0 },
  value: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.125rem',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  }),
  valueItalic: (theme) => ({
    fontFamily: theme.typography.displayItalic.fontFamily,
    fontStyle: 'italic',
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.125rem',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  }),
};
